import Adicionar from './Adicionar';
import AlterarMinhaSenha from './AlterarMinhaSenha';
import Default from './Default';
import Editar from './Editar';
import Login from './Login';

const UsuariosDefault = Default;

export default UsuariosDefault;
export const UsuariosAdicionar = Adicionar;
export const UsuariosEditar = Editar;
export const UsuariosLogin = Login;
export const UsuariosAlterarMinhaSenha = AlterarMinhaSenha;
